export enum ProposalStatus {
  OPEN = 'OPEN',
  EXPIRED = 'EXPIRED',
  COMPLETE = 'COMPLETE',
  RETRACTED = 'RETRACTED',
}
